'use client'
import { cx } from 'lib/cx'
import { useToaster } from 'react-hot-toast/headless'
import type { NotificationProps } from './Notification'
import Notification from './Notification'

export default function Notifications({
  position = 'left',
}: {
  position?: 'left' | 'right'
}) {
  const { toasts, handlers } = useToaster()
  const { startPause, endPause } = handlers

  if (!toasts.length) return null
  return (
    <div
      className={cx(
        'fixed top-12 z-50 flex flex-col gap-3 p-4',
        position === 'left' ? 'left-0' : 'right-0',
      )}
      onMouseEnter={startPause}
      onMouseLeave={endPause}
    >
      {toasts
        .filter((toast) => toast.visible)
        .map((toast) => (
          <Notification
            key={toast.id}
            {...toast.ariaProps}
            toast={toast as NotificationProps['toast']}
          />
        ))}
    </div>
  )
}
